//import { ServiceClient } from 'src/utils'
//const serviceClient = ServiceClient.singleton()

export class UserProfileService {
    static #INSTANCE = new UserProfileService()
    static readonly singleton = () => UserProfileService.#INSTANCE

}

export default UserProfileService.singleton()
